var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInnovation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 94,
    viewBox: "0 0 95 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2622_10516)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 47,
    r: 31,
    fill: "#00C67F",
    fillOpacity: 0.11
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2622_10516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5005 57.1863V62H52.5005V57.3938C52.476 56.3283 52.6787 55.2697 53.0951 54.2886C53.5115 53.3076 54.132 52.4264 54.9155 51.7038C56.6253 50.205 57.8409 48.2234 58.402 46.02C58.9632 43.8166 58.8435 41.4949 58.0587 39.3609C57.274 37.2268 55.861 35.3807 54.0061 34.0658C52.1511 32.7508 49.9413 32.0288 47.6678 31.9949C45.3944 31.961 43.164 32.6167 41.2706 33.8758C39.3773 35.1348 37.9099 36.9379 37.0618 39.0476C36.2138 41.1572 36.0249 43.4743 36.52 45.6935C37.0151 47.9127 38.1711 49.9297 39.8355 51.4788C40.6507 52.1937 41.3086 53.0702 41.7673 54.0527C42.2261 55.0352 42.4757 56.1022 42.5005 57.1863ZM50.0005 59.5H45.0005V57.1863C45.0005 57.1238 44.9917 57.0613 44.9905 57H50.0205C50.0205 57.1313 50.0005 57.2613 50.0005 57.3938V59.5ZM38.8255 42.0938C39.0113 40.6915 39.5343 39.3552 40.3497 38.1993C41.1651 37.0434 42.2486 36.1025 43.5073 35.4571C44.766 34.8117 46.1625 34.4811 47.577 34.4936C48.9914 34.5061 50.3818 34.8613 51.6289 35.5289C52.876 36.1964 53.9427 37.1564 54.7376 38.3265C55.5324 39.4966 56.0317 40.8419 56.1928 42.2473C56.3538 43.6526 56.1717 45.076 55.6621 46.3956C55.1524 47.7151 54.3305 48.8915 53.2667 49.8238C51.8755 51.0694 50.8791 52.695 50.4005 54.5H48.7505V45.52C49.4791 45.2624 50.1103 44.786 50.5578 44.1559C51.0053 43.5258 51.2473 42.7728 51.2505 42H48.7505C48.7505 42.3315 48.6188 42.6495 48.3843 42.8839C48.1499 43.1183 47.832 43.25 47.5005 43.25C47.1689 43.25 46.851 43.1183 46.6166 42.8839C46.3822 42.6495 46.2505 42.3315 46.2505 42H43.7505C43.7537 42.7728 43.9956 43.5258 44.4431 44.1559C44.8906 44.786 45.5218 45.2624 46.2505 45.52V54.5H44.598C44.0342 52.6365 42.9769 50.9603 41.538 49.6488C40.5124 48.6998 39.7304 47.5179 39.2583 46.2028C38.7861 44.8878 38.6377 43.4783 38.8255 42.0938Z",
    fill: "#20435D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2622_10516",
    x: 0.5,
    y: 0,
    width: 94,
    height: 94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_2622_10516"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2622_10516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(32.5 32)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovation);
export default __webpack_public_path__ + "static/media/innovation.643afae206b43c0e7c3170e07f78fd38.svg";
export { ForwardRef as ReactComponent };